import { render, staticRenderFns } from "./Terminology.vue?vue&type=template&id=f0c4306a&"
import script from "./Terminology.vue?vue&type=script&lang=ts&"
export * from "./Terminology.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports